"use client";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";

export default function Server({}) {
	const t = useTranslations("product");

	return (
		<div className="mt-4 flex flex-col gap-4">
			<div className="flex gap-3">
				<img src="/image/wuliu.svg" alt="" className="h-[26px] w-[26px]" />
				<p className="font-abeezee leading-[25px]">{t("time")}</p>
			</div>
			<div className="flex gap-3">
				<img src="/image/baoguo.svg" alt="" className="h-[26px] w-[26px]" />
				<p className="font-abeezee leading-[25px]">{t("return")}</p>
			</div>
			{/* 支付方式 */}
			<div className="flex min-h-[120px] w-full  items-center justify-center border-[1px] border-[#E0E0E0]">
				<div className="flex flex-col items-center justify-center gap-2">
					<span className="flex flex-wrap items-center justify-center gap-4">
						{Array.from({ length: 10 }).map((item, index) => {
							return (
								<img
									key={index}
									src={`/image/payment/${index + 1}.svg`}
									alt=""
									className="h-[30px] w-[50px]"
								/>
							);
						})}
					</span>
					<p className="font-abeezee text-[16px]">{t("safe")}</p>
				</div>
			</div>
			{/* 联系我们 */}
			<div className="mt-[20px] flex h-[90px] w-full items-center justify-start border-[1px] border-[#E0E0E0]">
				<div className="flex flex-col items-start justify-start gap-1  px-[22px]">
					<p className="font-Poppins flex items-center justify-center gap-4 text-[16px]  font-bold leading-[21px]">
						{t("contact")}
					</p>
					<Link href="/contact-us" className="!text-black hover:!text-[#8F9696]">
						<p className="font-abeezee !text-[16px]  leading-[26px] !underline ">{t("contactUs")}</p>
					</Link>
				</div>
			</div>
		</div>
	);
}
